import LOCALS from 'commons/locals';
import i18n from 'i18n';

export const PUBLISH_STATUS_MAP = {
  ON_SHELF: 1,
  OFF_SHELF: 0,
};

export const PUBLISH_STATUS_OPTION_LIST = [
  {
    value: PUBLISH_STATUS_MAP.ON_SHELF,
    label: i18n.t(LOCALS.on_shelf),
  },
  {
    value: PUBLISH_STATUS_MAP.OFF_SHELF,
    label: i18n.t(LOCALS.off_shelf),
  },
];

export const PROMOTION_TYPE_MAP = {
  // 非特价
  NORMAL: 0,
  // 特价
  SPECIAL: 1,
};

export const PRODUCT_SOURCE_TYPE_MAP = {
  /** 回收 */
  RECYCLE: 0,
  /** 寄卖 */
  CONSIGNMENT: 1,
  /** 采购 */
  PROCUREMENT: 2,
};

export const PRODUCT_SOURCE_TYPE_OPTION_LIST = [
  {
    value: PRODUCT_SOURCE_TYPE_MAP.RECYCLE,
    label: i18n.t(LOCALS.recycle),
  },
  {
    value: PRODUCT_SOURCE_TYPE_MAP.CONSIGNMENT,
    label: i18n.t(LOCALS.consignment),
  },
  {
    value: PRODUCT_SOURCE_TYPE_MAP.PROCUREMENT,
    label: i18n.t(LOCALS.procurement),
  },
];
